export enum BannerSubcategory {
    PREMIUM = 'CREATE',
    PO = 'REMOVE',
}

export function determineBannerSubcategory(
    isPOFeatureEnabled: boolean,
    isLTOFeatureEnabled: boolean,
    isTeamsFeatureEnabled: boolean,
): BannerSubcategory | null {
    if (isTeamsFeatureEnabled || isLTOFeatureEnabled) {
        return BannerSubcategory.PREMIUM
    } else if (isPOFeatureEnabled) {
        return BannerSubcategory.PO
    } else {
        return null
    }
}
